import { Man } from "@mui/icons-material";

export let action = {
  LOGOUT: "Logout",
  LOGO: "CPV-Auto Batch Processing Platform",
  SEARCH: "Search",
  PROJECT: "Project",
  BATCH: "Batch",
  CLEAR: "Clear",
  SETTINGS: "Settings",
  SEARCH_BATCH: "Search Batch..",
  Folder: "Folder",
  File: "File",
  TASKSTATUS: "Task Status",
  AUDITTRAIL: "Audit Trail",
  INVESTIGATION: "Search & Investigate",
  VISUALIZATION: "SRM",
  DATAPREVIEW: "Data Preview",
  LOGS: "Logs",
  TEMPLATE: "Template",
  PROCESS: "Process",
  LIMIT: "LIMIT",
  MANAGE_DATA: "Manage Data",
  PROCESS_CONFIG: "Configuration",
  AUDIT_TRAIL: "Audit Trail",
};
